import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneDynamicIsland: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="phone-dynamic-island"><path d="M10.75 4.25H13.25M5.75 1.75H18.25V22.25H5.75V1.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPhoneDynamicIsland;
